<div *ngIf="catalogPropertyService.hasProperty(carType?.Properties,propertyKind)" class="flex-parent-element">
  <div class="fw-light flex-child-element">{{label || catalogPropertyService.getPropertyTranslation(propertyKind)}}</div>
  <div class="text-end fw-bold  flex-child-element">{{catalogPropertyService.getPropertyValueString(carType?.Properties, propertyKind)}}</div>
</div>